<template>
  <div class="wrapp-store-result">
    <div class="wrapp-totals">
      <span class="text">{{$t('totals')}}:  {{totalCount}}</span>
      <div class="wrapp-view-mode">
        <button
        class="btn btn-icon btn-icon-xsmall btn-rounded"
        v-for="(layout, index) in listLayout"
        :key="index"
        v-html="layout.icon"
        :class="{ 'active': index === activeLayoutIndex }"
        @click.prevent="setCurrentLayout(index)"></button>
      </div>
    </div>
    <div class="wrapp-stores">
      <div class="wrapp-stores-wrapp">
        <component :is="currentComponentLayout" :stores="stores" :inputText="inputText" :isCheckoutMode="isCheckoutMode" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'
import StoresList from 'theme/components/Search/Tiles/Stores/StoresList'
import StoresMap from 'theme/components/Search/Tiles/Stores/StoresMap'

export default {
  name: 'Stores',
  props: {
    searchResponse: {
      type: Array | Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    },
    isCheckoutMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeLayoutIndex: 1,
      currentComponentLayout: '',
      listLayout: [
        {
          name: 'list-on-map',
          icon: '<svg class="o-icon"><use xlink:href="#map"></use></svg>',
          component: 'StoresMap'
        },
        {
          name: 'ul-list',
          icon: '<svg class="o-icon"><use xlink:href="#list-ul"></use></svg>',
          component: 'StoresList'
        }
      ]
    }
  },
  computed: {
    stores () {
      if (this.searchResponse) {
        return this.searchResponse
      } else {
        return []
      }
    },
    totalCount () {
      return this.searchResponse.length || 0
    }
  },
  methods: {
    setCurrentLayout (index = null) {
      let layoutIndex = 1
      if (index !== null) {
        layoutIndex = index
      }
      this.activeLayoutIndex = layoutIndex
      this.currentComponentLayout = this.listLayout[layoutIndex].component
      return this.currentComponentLayout
    }
  },
  mounted () {
    if (process.client) {
      this.setCurrentLayout()
    }
  },
  components: {
    BaseCheckBox,
    StoresList,
    StoresMap
  }
}
</script>
